import React from 'react'

const contact = () => {
  return (
    <div>
        <h1>hello</h1>
      
    </div>
  )
}

export default contact
